import React from 'react'
import {EmblaCarouselType, EmblaOptionsType} from 'embla-carousel'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay, {AutoplayOptionsType} from 'embla-carousel-autoplay'

import "./EmblaCarousel.scss";

type PropType = {
  options?: EmblaOptionsType;
  onRender?: (emblaApi: EmblaCarouselType) => void;
  children?: React.ReactNode;
  autoPlayOptions?: AutoplayOptionsType;
}

const EmblaCarousel: React.FC<PropType> = (props) => {
  const {options, children, onRender } = props;
  let autoPlayOptions: AutoplayOptionsType = props.autoPlayOptions || { playOnInit: false, delay: 3000 };

  const [emblaRef, emblaApi] = useEmblaCarousel(options, [
    Autoplay(autoPlayOptions)
  ]);
  if (onRender) onRender(emblaApi);

  return (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {children}
        </div>
      </div>
    </div>
  )
}

export default EmblaCarousel
